
export const transform = ({
							  report_id,
							  report_type_id,
							  person_id,
							  type,
							  score,
							  quantity,
							  execution_level,
							  alert,
							  remarks,
							  isexpired,
}) => (
	{
		report_id: report_id,
		report_type_id: report_type_id,
		person_id: person_id,
		type: {
			id: type.id,
			name: type.name
		},
		score: score,
		quantity: quantity,
		execution_level: execution_level,
		alert: alert || false,
		remarks: remarks,
		isexpired:isexpired,
	}
);


transform.reverse = (evaluation) => ({
	report_id: evaluation.report_id,
	report_type_id: evaluation.report_type_id,
	person_id: evaluation.person_id,
	type:{
		id: evaluation.type.id,
	},
	score: evaluation.score,
	quantity: parseInt(evaluation.quantity),
	execution_level: evaluation.execution_level === null ? 20 : evaluation.execution_level,
	alert: evaluation.alert || false,
	remarks: evaluation.remarks
});

